export default __webpack_public_path__ + "static/media/campaigns.39d20dcb.svg";